// extracted by mini-css-extract-plugin
export default {"container":"loader_container__pYL3R","logo":"loader_logo__Yl5EC","bounce":"loader_bounce__LHmDn","shadow":"loader_shadow__2mXIl","grow":"loader_grow__Fh1xp"};